import { useQuery } from '@tanstack/react-query'
import { assinaturaApi } from '../../api/endpoints'

/** Mapa de recursos do plano vigente (catálogo de recursos por plano). */
export function useRecursos() {
  const { data, isLoading } = useQuery({ queryKey: ['assinatura'], queryFn: assinaturaApi.minha, staleTime: 60_000 })
  return { carregando: isLoading, recursos: data?.recursos }
}

/** Um recurso do catálogo. Sem a assinatura carregada ou sem o mapa, libera: a API é quem barra de verdade. */
export function useRecurso(chave: string) {
  const { carregando, recursos } = useRecursos()
  if (carregando || !recursos) return { habilitado: true, limite: null as number | null, carregando }
  const r = recursos[chave]
  // Chave ausente do mapa = recurso que o plano não tem.
  return { habilitado: r?.habilitado ?? false, limite: r?.limite ?? null, carregando }
}
